import { useCallback, useRef } from 'react';

import { useMapStoreContext } from '@/microfrontends/map/shared/context/mapStoreContext';

export const useMapSizeChanged = (): (() => boolean) => {
  const { map } = useMapStoreContext();

  const mapSize = useRef(map.container.getSize());

  return useCallback(() => {
    const newMapSize = map.container.getSize();
    const isMapSizeChanged = mapSize.current !== newMapSize;

    if (isMapSizeChanged) {
      mapSize.current = newMapSize;
    }

    return isMapSizeChanged;
  }, [map.container]);
};
